// 导航

import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
    meta: null, // 路由meta
    matched: null,

    pageTitle: '王者财经',
    // tabIndex: 0,

    fullPath: '/',

    backUrl: ''
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
